<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
  },
  mounted() {
    // document.body.style.zoom = 1 / window.devicePixelRatio;
  },
}
</script>
<style lang="less" >
* {
  margin: 0;
  padding: 0;
}
body {
  margin: auto !important;
  padding: 0;
  font-family: Microsoft YaHei, Hiragino Sans GB, sans-serif;
}
li {
  list-style-type: none;
  list-style-position: outside;
}

</style>